<template>
  <div :class="mainClass">
    <div :class="{ background: true, hide: smallViewBrief }" @click="resetMenu"></div>

    <div :class="{ 'small-view': true, brief: smallViewBrief, 'sub-drawer-open': smallViewSubDrawer }">
      <div class="d-flex flex-column h-100">
        <div class="menu-btn" @click="resetMenu(true)">
          <img v-if="smallViewBrief" src="https://dsmlib.logistics.systems/Icons/Menu.png" alt="" />
          <img v-else src="https://dsmlib.logistics.systems/Icons/double-left.png" alt="" />
        </div>
        <div class="small-item-drawer">
          <div class="small-item-list tiny-scroll">
            <div
              :class="{
                'small-item': true,
                'small-menu-item': true,
                'active-tab': s.isActive,
                disabled: !s.enabled,
                'not-visible': !s.visible,
              }"
              v-for="(s, si) in menuList"
              :key="si"
            >
              <div class="small-item-button" @click="leftItemClick(s)">
                <div class="small-item-icon">
                  <img :src="s.icon" alt="" @error="(e) => (e.target.style.display = 'none')" />
                </div>
                <div class="small-item-text">{{ s.title }}</div>
              </div>
            </div>
            <div class="spacer" style="height: 20px">&nbsp;</div>
            <div class="powered-by-icon">
              <div class="powered-by-icon-inner">
                <div class="small-text">Powered </div>
                <div class="small-text"
                  >By
                  <img
                    class="copyright-logo short"
                    id="copyright-logo"
                    src="https://dsmlib.logistics.systems/Icons/Copyright.png"
                    alt="copyright"
                /></div>
                <div class="logo-text">Digital Systems </div>

                <div class="powered-img">
                  <img src="https://dsmlib.logistics.systems/Icons/DSM.GIF" alt="DSM Logo" />
                </div>
                <img
                  class="copyright-logo long"
                  id="copyright-logo"
                  src="https://dsmlib.logistics.systems/Icons/Copyright.png"
                  alt="copyright"
              /></div>
            </div>
          </div>

          <div class="small-item-sub-list tiny-scroll">
            <div class="small-item-sub small-menu-item title-item">
              <div class="small-item-button">
                <div class="small-item-icon">
                  <img :src="selectedIcon" />
                </div>
                <div class="small-item-text">{{ selectedMenu }}</div>
              </div>
            </div>
            <div
              v-for="sm in Object.keys(subMenuList)"
              :key="sm"
              :class="{
                'small-item-sub': true,
                'small-menu-item': true,
                disabled: subMenuList[sm].enabled != undefined ? !subMenuList[sm].enabled : false,
                'not-visible': subMenuList[sm].visible != undefined ? !subMenuList[sm].visible : false,
              }"
            >
              <div
                class="small-item-button"
                @click="subMenuItemClick(sm)"
                v-if="subMenuList[sm] && (subMenuList[sm]['pages'] || !subMenuList[sm].enabled)"
              >
                <div class="small-item-icon">
                  <img
                    v-if="subMenuList[sm].icon"
                    :src="subMenuList[sm].icon"
                    @error="(e) => (e.target.style.display = 'none')"
                  />
                </div>
                <div class="small-item-text">{{ sm }}</div>
              </div>
              <router-link
                :to="`/Home/${userParam}${subMenuList[sm].route}`"
                class="small-item-button"
                @click.native="subMenuItemClick(sm)"
                v-else
              >
                <div class="small-item-icon">
                  <img
                    v-if="subMenuList[sm].icon"
                    :src="subMenuList[sm].icon"
                    @error="(e) => (e.target.style.display = 'none')"
                  />
                </div>
                <div class="small-item-text">{{ sm }}</div>
              </router-link>

              <div
                v-if="subMenuList[sm] && subMenuList[sm]['pages']"
                :class="{ 'small-menu-dropdown': true, active: subMenuList[sm].dropdownActive }"
              >
                <div>
                  <router-link
                    :to="`/Home/${userParam}${s.route}`"
                    v-for="(s, is) in subMenuList[sm]['pages']"
                    :key="is"
                    :class="{ 'small-menu-dropdown-item': true, 'small-item-button': true, 'not-visible': !s.visible }"
                    @click.native="subMenuItemClick(s)"
                  >
                    <div class="small-item-icon">
                      <img v-if="s.icon" :src="s.icon" @error="(e) => (e.target.style.display = 'none')" />
                    </div>
                    <div class="small-item-text">{{ s.title }}</div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="under-construction" v-if="Object.keys(subMenuList).length == 0">
              This menu is still under construction
            </div>

            <div class="spacer" style="height: 40px; flex-shrink: 0" v-else>&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      subMenuList: {},
      menuList: [],

      mainClass: 'main main-hide',
      selectedMenu: 'Logistics',
      selectedIcon: '',

      smallViewBrief: true,
      smallViewSubDrawer: false,

      userParam: '',
      loginDetails: null,
    };
  },
  methods: {
    leftItemClick: function (item) {
      if (!item.enabled) {
        return;
      }

      this.smallViewSubDrawer = true;
      this.smallViewBrief = false;

      this.menuList.forEach((m) => {
        m.isActive = false;
      });

      item.isActive = true;
      const resetSubMenu = Boolean(this.selectedMenu != item.title);
      this.selectedMenu = item.title;
      this.selectedIcon = item.icon;

      const subItems = item.items;

      if (resetSubMenu) {
        Object.keys(subItems).forEach((key) => {
          this.$set(subItems[key], 'dropdownActive', false);
        });
      }

      this.subMenuList = subItems;
    },
    subMenuItemClick(subMenu) {
      const subMenuItem = this.subMenuList[subMenu];
      const { enabled, pages, dropdownActive } = subMenuItem || {};

      if (enabled != undefined && !enabled) return;
      if (subMenuItem && pages) {
        this.$set(subMenuItem, 'dropdownActive', !dropdownActive);
        return;
      }

      this.resetMenu();
    },

    resetMenu(menuToggle = false) {
      this.smallViewBrief = menuToggle ? !this.smallViewBrief : true;
      this.smallViewSubDrawer = false;
      Object.keys(this.menuList).forEach((key) => {
        this.menuList[key].isActive = false;
      });

      Object.keys(this.subMenuList).forEach((key) => {
        this.$set(this.subMenuList[key], 'dropdownActive', false);
      });
    },

    handleClickOutside(event) {
      const target = event.target;
      if (!this.$el.contains(target)) {
        this.resetMenu();
      }
    },
    handleRouteChanged() {
      this.resetMenu();
    },
  },
  async mounted() {
    this.userParam = this.$route.params['user'];
    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');
    if (this._isDestroyed) return;

    const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?page=HOME`);
    if (this._isDestroyed) return;

    const menus = this.$subMenu.getMenus();
    menus.forEach((m) => {
      m.isActive = false;
      m.isHover = false;

      const accessControl = sasControl.find((s) => {
        return s.Control == m.key;
      });

      if (accessControl) {
        m[accessControl.Properties.toLowerCase()] = accessControl.PropertiesValue == 'True';
      }
      this.$apiCallV2(`/SASControl/GetSASControlAccess?system=${m.key}`).then((r) => {
        Object.keys(m.items).forEach((k) => {
          if (Array.isArray(m.items[k]['pages'])) {
            m.items[k]['pages'].forEach((i) => {
              const control = r.find((c) => c.Control == i.key);
              if (control) {
                i[control.Properties.toLowerCase()] = control.PropertiesValue == 'True';
              }
            });
          } else {
            const control = r.find((c) => c.Control == m.items[k].key);
            if (control) {
              m.items[k][control.Properties.toLowerCase()] = control.PropertiesValue == 'True';
            }
          }
        });
      });
    });

    //#region Remove Broadcast Message for company different than DSM
    if (!this.loginDetails['ConfigCode'].toLowerCase().includes('dsm6g')) {
      const settingMenu = menus.find((m) => m['title'] == 'Settings');
      settingMenu['items']['Broadcast Message']['visible'] = `false`;
    }
    //#endregion

    this.menuList = menus;
    this.$subMenu.setSASMenus(this.menuList);

    this.$bus.$on('routeChanged', this.handleRouteChanged);

    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    this.$bus.$off('routeChanged', this.handleRouteChanged);
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.main {
  display: flex;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 999;
  pointer-events: none;
}

.background {
  width: 200%;
  height: 100%;
  position: fixed;
  top: 50px;
  z-index: 1;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.5) 50%, transparent);
  transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
  transform-origin: left;
  pointer-events: all;
  &.hide {
    pointer-events: none;
    transform: translateX(-100%);
    transition: all 0.35s ease;
  }
}

.small-view {
  --min-width: 40px;
  position: fixed;
  left: 0;
  z-index: 1000;
  height: 100%;
  pointer-events: none;
  word-spacing: -4px;
  line-height: 1.15;
  z-index: 2;
  .menu-btn {
    width: var(--min-width);
    min-height: 50px;
    max-height: 50px;
    padding: 4px 8px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    z-index: 2;

    pointer-events: all;

    img {
      width: 100%;
    }
    user-select: none;
  }

  .small-item-drawer {
    display: flex;
    height: calc(100% - 50px);
  }

  --submenu-width: 220px;

  &.sub-drawer-open {
    --submenu-width: 0px;
  }

  .small-item-sub-list {
    position: relative;
    z-index: 2;
    background-color: white;
    width: 220px;
    height: 100%;
    border-right: 1px solid #a7a7a7;
    transform: translateX(calc(var(--submenu-width) * -1));

    display: flex;
    flex-direction: column;

    transition: all 0.1s ease-out;

    overflow-x: clip;
    overflow-y: auto;

    border-top: 1px solid gray;
    .small-menu-item {
      border-right: 1px solid #a7a7a7;
      &:not(.title-item) {
        --min-width: 36px;
      }
    }

    pointer-events: all;
  }

  &.brief {
    .small-item-list {
      width: var(--min-width);
    }

    .powered-by-icon {
      .powered-by-icon-inner {
        gap: 0px;
        width: var(--min-width);
      }
      .small-text {
        padding-top: 0px;
      }
      .logo-text {
        display: none;
      }
      .copyright-logo {
        &.short {
          display: block;
        }
        &.long {
          display: none;
        }
      }
    }

    .small-item-list:hover {
      width: var(--submenu-width);
      .powered-by-icon {
        .powered-by-icon-inner {
          width: var(--submenu-width);
          gap: 2px;
        }
        .logo-text {
          display: block;
        }
        .small-text {
          padding-top: 1px;
        }

        .copyright-logo {
          &.short {
            display: none;
          }
          &.long {
            display: block;
          }
        }
      }
    }
  }

  .small-item-list {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #a7a7a7;
    position: relative;
    z-index: 3;

    width: 220px;
    transition: all 0.15s ease-out;
    overflow-x: clip;
    overflow-y: auto;

    border-top: 1px solid gray;

    pointer-events: all;

    &:has(.small-menu-item.active-tab) {
      .small-menu-item:not(.active-tab):not(.disabled) {
        .small-item-button {
          * {
            opacity: 0.5;
          }
          img {
            opacity: 0.75;
          }
        }
      }
    }
  }

  .small-menu-item {
    width: 220px;
    overflow: hidden;
    user-select: none;
    flex-shrink: 0;
    text-decoration: none !important;
    color: inherit !important;
    * {
      text-decoration: none !important;
      color: inherit !important;
    }

    &.disabled {
      color: #797979 !important;
      .small-item-button {
        img {
          opacity: 0.75 !important;
        }
        cursor: not-allowed !important;
        background-color: lightgray !important;
      }
    }

    &.not-visible {
      display: none;
    }

    &:has(> .small-menu-dropdown) {
      > .small-item-button {
        .small-item-text {
          margin-right: auto;
        }
        &::after {
          content: '';
          width: 6px;
          height: 6px;
          border-bottom: 2px solid black;
          border-right: 2px solid black;
          margin-left: 4px;
          margin-right: 4px;
          transform: translateY(-1px) rotate(45deg);
          transition: all 0.1s ease;
          flex-shrink: 0;
        }
      }
    }

    &:has(> .small-menu-dropdown.active) {
      > .small-item-button {
        background-color: #f3f3f3;
        &::after {
          transform: translateY(2px) rotate(225deg);
        }
      }
    }

    &.active-tab {
      .small-item-button {
        background-color: #f4f5ff !important;
        border-left-width: 6px;

        transition: border-left-width 0.05s ease-in;
      }
    }

    .small-menu-dropdown {
      display: grid;
      grid-template-rows: 0fr;
      transition: all 0.1s ease-in-out;
      > div {
        overflow: hidden;
      }

      position: relative;

      .small-item-button {
        min-height: 30px;
        border-color: #ebebeb;
        &:last-child {
          border-color: #cfcfcf;
        }
      }

      &.active {
        grid-template-rows: 1fr;
      }
    }

    .small-item-button {
      width: 100%;
      display: flex;
      min-height: var(--min-width);
      justify-content: start;
      align-items: center;
      cursor: pointer;
      padding-right: 8px;
      border-bottom: 1px solid #cfcfcf;
      border-left: 0px solid #535cda;
      &:hover {
        background-color: #f3f3f3;

        * {
          opacity: 1 !important;
        }
      }
    }
    .small-item-icon {
      min-width: var(--min-width);
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 65%;
        object-fit: contain;
      }
      flex: 0 0 var(--min-width);
    }

    .small-item-text {
      font-size: 0.75rem;
      padding-right: 4px;
      color: black;
    }

    &.title-item {
      position: sticky;
      top: 0;
      .small-item-button {
        font-weight: bold;
        cursor: auto;
        background-color: #f4f5ff;
        border-color: #a7a7a7;
      }
      z-index: 1;
    }
  }

  .tiny-scroll {
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .powered-by-icon {
    border-top: 1px solid #a7a7a7;
    position: sticky;
    bottom: 0;
    margin-top: auto;
    background-color: white;
    z-index: 2;

    .powered-by-icon-inner {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 4px 4px;
      width: 220px;
      justify-content: center;
      gap: 2px;
    }

    .small-text {
      font-size: 0.5rem;
      text-align: center;
      line-height: 1.15;
      display: flex;
      gap: 2px;
      align-items: center;
      padding-top: 1px;
    }

    .powered-img {
      height: 16px;
      display: flex;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .logo-text {
      font-weight: bold;
      font-size: 0.65rem;
      margin-left: 4px;
      margin-right: 2px;
    }

    .copyright-logo {
      height: 7px;
      &.short {
        display: none;
      }

      &.long {
        width: 1px;
        margin-left: 2px;
        object-fit: cover;
        overflow: visible;
        transform: translateY(-4px);
      }
    }
  }

  .under-construction {
    font-size: 0.75rem;
    padding: 8px;
    width: 100%;
    flex-grow: 1;
    background-color: #fcfcfc;
  }
}
</style>
